import { render, staticRenderFns } from "./HorseDetail.vue?vue&type=template&id=cebdf000&"
import script from "./HorseDetail.vue?vue&type=script&lang=js&"
export * from "./HorseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports